import { useEffect, useState } from 'react'
const { detect } = require('detect-browser')

/**
 * @typedef {Object} WhoIs
 * @property {string} os
 * @property {string} browserName
 * @property {string} browserVersion
 * @property {string} ip
 * @property {string} city
 * @property {string} country
 * @property {string} isp
 */

function useWhoIs() {
  const browser = detect()

  const [ip, setIp] = useState('')
  const [city, setCity] = useState('')
  const [country, setCountry] = useState('')
  const [isp, setIsp] = useState('')

  const { os, name, version } = browser

  useEffect(() => {
    fetch('https://hutils.loxal.net/whois')
      .then(res => res.json())
      .then(res => {
        setIp(res.ip)
        setCity(res.city)
        setCountry(res.country)
        setIsp(res.isp)
      })
      .catch(err => {
        console.warn(err)
      })
  }, [])

  return {
    os,
    browserName: name,
    browserVersion: version,
    ip,
    city,
    country,
    isp
  }
}

export default useWhoIs
